import { createStore } from "vuex";
export default createStore({
  state: {
    allow_pick_paper_school: global.gz
      ? global.gz.allow_pick_paper_school
      : ["90005", "65799"],
    skill: {
      S0: "词汇",
      S1: "听力",
      S2: "阅读",
      S3: "语法",
      S4: "写作",
      S5: "口语",
      S9: "综合测试",
    },
    skillText: {
      word: "S0",
      listen: "S1",
      reading: "S2",
      grammar: "S3",
      writing: "S4",
      oral: "S5",
      mock: "S9",
    },
    values: {
      mcq: "选择题",
      mmcq: "多选题",
      judge: "判断题",
      saq: "填空题",
      pwco: "连词组句",
      mm: "匹配题",
      sequencing: "排序题",
      proofreading: "改错题",
      proofreading_other: "全文改错",
      writing: "写作题",
      "mcq-hollow": "选择题",
      oral: "口语题",
    },
    level: {
      title: "大学生英语能力诊断系统",
      user_examlist: "我的考试",
      user_self_evaluation: "自评",
      type_self_evaluation: "1",
      type_vspt: "2", // 词汇测试
      type_survy: "3", // 调查问卷
      type_first: "4", // 定级卷
      type_second: "5", // 诊断卷
      type_other: "6", // 试测卷
    },
    eval: {
      CORE_TYPE_SENT: "sent.eval.pro", // 句子内核
      CORE_TYPE_OPEN: "open.eval", // 开放题型内核
      CORE_TYPE_PARA: "para.eval", // 段落内核
    },
    recorderKey: {
      appKey: "150898365400003b",
      secretKey: "f6ea2edad63d14cbe1c3af12ac78bd13",
    },
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
